import React from 'react';

// Reusable "this person is your friend" chip — used on the leaderboard rows
// today; will sit on any list that surfaces other users later.

interface Props {
  /** When true, renders as a filled amber pill; otherwise hidden (so callers
   * can `<FriendBadge active={row.is_friend} />` unconditionally). */
  active?: boolean;
  /** Override default emoji (defaults to 👥). */
  icon?: string;
  /** Optional label next to the icon. */
  label?: string;
  title?: string;
}

const FriendBadge: React.FC<Props> = ({ active = true, icon = '👥', label, title = 'friend' }) => {
  if (!active) return null;
  return (
    <span className="sk-pill amber" style={{ fontSize: 10, gap: 4 }} title={title}>
      {icon}
      {label !== undefined ? <span style={{ marginLeft: 4 }}>{label}</span> : null}
    </span>
  );
};

export default FriendBadge;
